import React from 'react';
import { PunchOut } from '@hpi-sox/hpstellar-core';
import { Typography } from '@hpi-sox/hpstellar-core/visId';
import withPageComponents from '../../../page/components/with-page-components';
import AdaptiveImage from '../../../shared/components/adaptive-image';
import DeliveryMessage from '../../components/sticky-header/delivery-message';
import ProductIdentityDetails from '../../components/product-identity-details';
import { Helpers } from '../../../core/src/helpers';
import SavingsProgressBar from '../../components/savings-progress-bar';

import './configure-title.less';

export default withPageComponents(
    ({ baseConfig = {}, ctoPrice: price, customizeText = 'Customize your', froggerMessage, innerWidth }) => {
        const { title, image, shipsText, alternateImage } = baseConfig;
        const shippingMessage = froggerMessage || shipsText;

        const mobile = innerWidth < 768;

        return (
            <>
                <div className="configure-title-v2">
                    {image && (
                        <AdaptiveImage
                            className="configure-title-v2-image"
                            src={Helpers.purifyUrl(alternateImage || image)}
                            maxWidth={120}
                            prefetch={true}
                        />
                    )}
                    <div className="sub-header-wrapper">
                        <Typography tag="h2" variant="h3" weight="700" className="customize-text">
                            {customizeText}
                        </Typography>
                        <Typography tag="h1" variant="h3" className="sub-header">
                            {title}
                        </Typography>
                        <ProductIdentityDetails />
                        <DeliveryMessage visId />
                    </div>
                </div>
                {mobile && shippingMessage && (
                    <Typography
                        variant="bodyS"
                        className="shipping-html-visId configure-title-shipping"
                        dangerouslySetInnerHTML={Helpers.createMarkup(shippingMessage)}
                    />
                )}
                {mobile && <SavingsProgressBar v2 />}
            </>
        );
    },
    { components: ['baseConfig', 'ctoProductInitial', 'ctoPrice', 'shipDate', 'froggerMessage'], device: true },
);
